import React from 'react';
import { HiOutlineX } from 'react-icons/hi';

const ImagePreview = ({ image, onRemove }) => {
    return (
        <div className="relative group">
            <div className="w-14 h-14 overflow-hidden rounded-xl border-2 border-gray-200 dark:border-gray-700 shadow-sm bg-gray-100 dark:bg-gray-800">
                <img
                    src={image.url}
                    alt="Selected"
                    className="w-full h-full object-contain transition-transform group-hover:scale-105"
                    onError={(e) => {
                        e.target.src = '/img/placeholder-image.png'; // Fallback image
                    }}
                />
            </div>
            
            {/* Remove Button */}
            <button
                onClick={onRemove}
                className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center shadow-lg transition-all transform hover:scale-110 opacity-0 group-hover:opacity-100 z-[2]"
                title="Remove image"
            >
                <HiOutlineX className="w-3 h-3 text-white" />
            </button>
            
            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-black/20 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
    );
};

export default ImagePreview; 